import React from "react";
import { Form, Dropdown, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAuth } from "../../../hook/userAuth";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../../ruta-server/BaseApi";

export function AddEditPersonalNA(props) {
  const { onClose, onRefetch, personalNA } = props;
  const { auth } = useAuth();

  const updatePersonal = async (id, data) => {
    try {
      await updatePersonalNAApi(id, data, auth.token);
    } catch (error) {
      throw error;
    }
  };

  async function updatePersonalNAApi(id, data, token) {
    try {
      const url = `${BASE_API}/api/users/${id}/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.patch(url, data, { headers });
      return response.data;
    } catch (error) {
      toast.error("Error al asignar rol para el personal");
      throw error;
    }
  }

  const formik = useFormik({
    initialValues: initialValues(personalNA),
    validationSchema: Yup.object(updateSchema()),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        await updatePersonal(personalNA.id, formValue);
        onRefetch();
        onClose();
      } catch (error) {
        console.error(error);
      }
    },
  });

  const handleDropdownChange = (_, datos) => {
    const selectedRole = datos.value;

    let isSuperuser = false;
    let esDocente = false;
    let esPersonalControlEscolar = false;

    if (selectedRole === "Personal Administrador") {
      isSuperuser = true;
    } else if (selectedRole === "Personal Docente") {
      esDocente = true;
    } else if (selectedRole === "Personal Control Escolar") {
      esPersonalControlEscolar = true;
    }

    formik.setValues({
      ...formik.values,
      is_superuser: isSuperuser,
      es_docente: esDocente,
      es_personal_control_escolar: esPersonalControlEscolar,
      rol_asignado: selectedRole,
    });
  };

  const rolesDisponibles = [
    {
      key: "1",
      text: "Personal Administrador",
      value: "Personal Administrador",
    },
    { key: "2", text: "Personal Docente", value: "Personal Docente" },
  ];

  return (
    <>
      <div className="divcampo">
        <label className="astedisco">*</label>
        <label className="campR"> Campo requerido</label>
      </div>
      <Form className="add-edit-user-form" onSubmit={formik.handleSubmit}>
        <label>
          Cargo asignado<span className="astedisco">*</span>
        </label>
        <Dropdown
          placeholder="Seleccione un cargo"
          fluid
          selection
          search
          name="rol_asignado"
          options={rolesDisponibles}
          value={formik.values.rol_asignado}
          error={formik.errors.rol_asignado}
          onChange={handleDropdownChange}
        />
        <Button
          type="submit"
          content={"Asignar cargo"}
          style={{ backgroundColor: "#008e86", color: "white" }}
          fluid
        />
      </Form>
      <ToastContainer />
    </>
  );
  function initialValues(datosUsuario) {
    return {
      username: datosUsuario?.username,
      telefono: datosUsuario?.telefono,
      email: datosUsuario?.email,
      first_name: datosUsuario?.first_name,
      apellido_materno: datosUsuario?.apellido_materno,
      last_name: datosUsuario?.last_name,
      password: "",
      curp: datosUsuario?.curp,
      categoria: datosUsuario?.categoria,
      grado_estudio: datosUsuario?.grado_estudio,
      cargo_asignado: datosUsuario?.cargo_asignado,
      is_active:
        datosUsuario?.is_active === undefined ? true : datosUsuario?.is_active,
      is_staff: true,
      is_superuser: datosUsuario?.is_superuser ?? true,
      es_docente: datosUsuario?.es_docente ?? true,
      es_personal_control_escolar:
        datosUsuario?.es_personal_control_escolar ?? true,
    };
  }

  function updateSchema() {
    return {
      rol_asignado: Yup.string().required(),
    };
  }
}
